export default function (element, data) {
    const closeBtn = element.querySelector(".close-btn");

    closeBtn.addEventListener("click", function(){
        window.dispatchEvent(new CustomEvent('close-popup-form'));
    });
    element.addEventListener("click", function(){
        window.dispatchEvent(new CustomEvent('close-popup-form'));
    });
    element.querySelector(".popup-form").addEventListener("click", function (event) {
        event.stopPropagation();
    });

    window.addEventListener("open-popup-form", function () {
        element.classList.add("open");
        document.body.classList.add("no-scroll");
    });
    window.addEventListener("close-popup-form", function () {
        element.classList.remove("open");
        document.body.classList.remove('no-scroll');
    });
}
